module.exports = __webpack_public_path__ + "static/media/simulation-planning.d2d59ebb.svg";